import CustomButton from "@components/buttons/CustomButton";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { invoiceServices } from "@services/apis/Invoice";
import { DeleteExchangeRequest } from "@services/models/InvoiceApprovals/DeleteExchangeModel";
import { GetExchangesData } from "@services/models/InvoiceApprovals/GetExchangesModel";
import { useState } from "react";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";

interface DeleteExchangeSliderProps {
  isOpen: boolean;
  onClose: () => void;
  onExchangeDeleted?: () => void;
  exchangeData?: GetExchangesData | null;
}

const DeleteExchangeSlider: React.FC<DeleteExchangeSliderProps> = ({
  isOpen,
  onClose,
  onExchangeDeleted,
  exchangeData,
}) => {
  const [deleteLoading, setDeleteLoading] = useState(false);

  const { handleSuccess, handleError } = useSnackbarMessage();

  const handleDelete= async () => {
    try {
      setDeleteLoading(true);
      const request: DeleteExchangeRequest = {
        exchangeId: exchangeData?.exchangeId || "",
      };
      await invoiceServices.deleteExchange(request);
      handleSuccess({ message: "Exchange deleted successfully" });
      if (onExchangeDeleted) {
        onExchangeDeleted();
      }
      onClose();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.msg || "Failed to deleteexchange";
      handleError({ message: errorMessage });
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <SlidingPanel
      isOpen={isOpen}
      heading={"Delete Exchange"}
      onClose={() => {
        onClose();
      }}
      onClickCross={() => {
        onClose();
      }}
      showConfirm={false}
      isSlider={false}
      widthDesktop={"35%"}
    >
      <div className="flex flex-col px-[16px] py-[16px]">
        <p className="text-text-base text-[14px] font-medium items-center justify-center text-center mb-[12px]">
          {
            "Delete Exchange?\nAre you sure you want to delete this exchange? This action cannot be undone and will permanently remove all associated data."
          }
        </p>
        <CustomButton
          text="DELETE EXCHANGE"
          onClick={handleDelete}
          isButtonLoading={deleteLoading}
          isActive={true}
          buttonColor="bg-bg-button-delete"
          borderColor="border-border-button-delete"
        />
      </div>
    </SlidingPanel>
  );
};

export default DeleteExchangeSlider;
